module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAB0SURBVBhX7c6xDYAwDERRj8cYLMMcjMI4lB7BkC5ChFwEZ1Gcpd/6nkWE1U3LHi9brXP1nn0E8BEEA7CdzSiCAiiPUQQNgCKoAARBB/QQKYAnRBqghUgF3CHSAVcEA+AFAeQswFACCCCAAAIIIIAAAvwKcAD27D1Y/f8QWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/file.png
// module id = 1614
// module chunks = 0